<template>
  <div id="card" class="card">
      <img :src="loadImg(imgSrc)" :alt="imgAlt">
      <h3>{{ title }}</h3>
      <p>形式： &nbsp; {{ fileType }}</p>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    imgSrc: String,
    imgAlt: String,
    title: String,
    fileType: String
  },
  methods: {
    loadImg: function (srcPath) {
      let image = require.context('@/assets/images', false, /\.png$|\.jpg$|\.svg$/)
      return image('./' + srcPath)
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 0.8rem 3.2rem 0 rgba(0,0,0, 0.2);
  background: var(--white);
  border-radius: 1.2rem;
  overflow: hidden;
  transition: .6s;
  position: relative;
}

.card:hover {
  box-shadow: 0 1.2rem 4.8rem 0 rgba(0,0,0, 0.3);
  cursor: pointer;
  transition: .2s;
}

img {
    width: 100%;
    height: auto;
}

h3 {
    font-size: var(--large-font-size);
    line-height: 1.55555555556 ;
    font-weight: var(--bold-font-weight);
    margin: 2.4rem 2.4rem 0;
}
p {
    font-size: var(--extra-small-font-size);
    line-height: 2;
    margin: 0.8rem 2.4rem 3.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Molecules/Card.vue